import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import store from './store'
import router from './router'

import axios from 'axios'
Vue.prototype.$http = axios

import AuthPlugin from './plugins/auth'

import './utils/filters'
import './custom.scss'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle, faCheckCircle, faTimesCircle, faTrashAlt, faEnvelope, faNewspaper, faEdit } from '@fortawesome/free-solid-svg-icons'
import { faMobileAlt, faFilePowerpoint  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCircle, faCheckCircle, faTimesCircle, faTrashAlt, faEnvelope, faNewspaper, faEdit, faMobileAlt, faFilePowerpoint)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuex)
Vue.use(AuthPlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
